import { backUrl } from "../utils/backURL";
import { withAuthCredentials } from "../utils/authFetchOptions";

/**
 * Fetches conversations by business with server-side pagination and optional date filter.
 * @param {string} token - Auth token
 * @param {string} businessId - Mantis business ID
 * @param {Object} options - { page, limit, dateFrom, dateTo, status, channel, tag }
 * @returns {Promise<{ data: Array, total: number, conversationsPerDay?: Array }>}
 */
export const getMantisConversationsByBusinessId = async (
  token,
  businessId,
  options = {}
) => {
  try {
    const params = {};
    if (options.page != null) params.page = options.page;
    if (options.limit != null) params.limit = options.limit;
    if (options.skip != null) params.skip = options.skip;
    if (options.dateFrom) params.dateFrom = options.dateFrom;
    if (options.dateTo) params.dateTo = options.dateTo;
    if (options.status) params.status = options.status;
    if (options.channel) params.channel = options.channel;
    if (options.tag) params.tag = options.tag;
    if (options.phone) params.phone = options.phone;

    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams
      ? `${backUrl}/mantis-conversations/business/${businessId}?${queryParams}`
      : `${backUrl}/mantis-conversations/business/${businessId}`;

    const response = await fetch(url, withAuthCredentials({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }));

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Error fetching conversations by business:", error);
    throw error;
  }
};

export const getMantisConversationMessagesByConversationId = async (
  token,
  conversationId,
  limit = 50,
  offset = 0
) => {
  try {
    const response = await fetch(
      `${backUrl}/mantis-conversation-messages/conversation/${conversationId}?limit=${limit}&offset=${offset}`,
      withAuthCredentials({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching messages by conversation:", error);
    throw error;
  }
};

export const getMantisConversationSessionsByConversationId = async (
  token,
  conversationId
) => {
  try {
    const response = await fetch(
      `${backUrl}/mantis-conversation-sessions/conversation/${conversationId}`,
      withAuthCredentials({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching conversation sessions:", error);
    throw error;
  }
};
